import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AddRecipe from "components/recipe/AddRecipe";
import React, { useEffect, useState } from "react";

const AddRecipeButton = ({ onAdd }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
    onAdd();
  };

  // Freeze background when modal is open
  useEffect(() => {
    if (isExpanded) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isExpanded]);

  return (
    <div className={`floating-button ${isExpanded ? "expanded" : ""}`}>
      {!isExpanded ? (
        <FontAwesomeIcon
          icon={faPlus}
          className="fa-2xl white button-icon"
          onClick={handleToggle}
        />
      ) : (
        <div
          className="form-content"
        >
          <div className="Row Space-B marg-b-1">
            <h2>Add New Recipe</h2>
            <button onClick={handleToggle} className="Green">
              <FontAwesomeIcon icon={faTimes} className="fa-2xl" />
            </button>
          </div>

          {/* Your form content here */}
          <div>
            <AddRecipe closeModal={handleToggle} />
          </div>
        </div>
      )}
    </div>
  );
};

export default AddRecipeButton;
